import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { UserService } from '../services/user/user.service';
import { LoginService } from '../services/authentication/login.service';

@Injectable()
export class HomeRedirectGuardService {
  constructor(
    private readonly router: Router,
    private readonly userService: UserService,
    private readonly loginService: LoginService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.userService.isAdmin()) {
      if (state.url == '/home') {
        this.router.navigate(['/admin']);
      }
      return true;
    } else if (this.userService.isReferencer()) {
      if (state.url == '/home') {
        this.router.navigate(['/referencer/home']);
      }
      return true;
    } else if (this.userService.isContributor()) {
      if (state.url == '/home') {
        this.router.navigate(['/contributor/home']);
      }
      return true;
    } else if (this.userService.isSuperAdmin()) {
      if (state.url == '/home') {
        this.router.navigate(['/dashboard']);
      }
      return true;
    } else {
      this.loginService.landingPage = state.url;
      this.router.navigate(['/account/login']);
      return false;
    }
  }
}
